import { useAppSelector } from '@/store/hooks';
import { getWorkingProjectSessions, selectIsSingleSession } from '@/store/slices/project/selectors';
import { useParams } from 'react-router-dom';

export const useWorkingSession = () => {
  const { sessionUuid } = useParams();
  const workingProjectSessions = useAppSelector(getWorkingProjectSessions);
  const isSingleSession = useAppSelector(selectIsSingleSession);
  if (isSingleSession) {
    return workingProjectSessions?.[0];
  }

  return workingProjectSessions?.find((s) => s.uuid === sessionUuid);
};
